export const BenefitBase = {
  Employees: "employees" as const,
  Name: "name" as const,
  BenefitValue: "benefitValue" as const,
  Frequency: "frequency" as const,
  BenefitType: "benefitType" as const,
}

export const BenefitCreate = {
  StartDate: "startDate" as const,
  EndDate: "endDate" as const,
  CarBenefitData: "carBenefitData" as const,
}

export const BenefitUpdate = {
  EmployeeDetails: "employeeDetails" as const,
  BenefitAmountEffectFrom: "benefitAmountEffectFrom" as const,
  ModelNumber: "modelNumber" as const,
  CostOfExtraEquipment: "costOfExtraEquipment" as const,
  AnnualTax: "annualTax" as const,
  IsAnnual10KmMileageMoreThan3000: "isAnnual10KmMileageMoreThan3000" as const,
  DateOfRegistration: "dateOfRegistration" as const,
}

export const EmployeeDetails = {
  User: "user" as const,
  DateRange: "dateRange" as const,
}

export const Filter = {
  Persons: "persons" as const,
  BenefitTypes: "benefitTypes" as const,
  MonthRange: "monthRange" as const,
  GroupSelection: "groupSelection" as const,
}

export const CarBenefitData = {
  SearchMethod: "searchMethod" as const,
  ModelNumber: "modelNumber" as const,
  CostOfExtraEquipment: "costOfExtraEquipment" as const,
  AnnualTax: "annualTax" as const,
  IsAnnual10KmMileageMoreThan3000: "isAnnual10KmMileageMoreThan3000" as const,
  Brand: "brand" as const,
  Year: "year" as const,
  Vehicle: "vehicle" as const,
  DateOfRegistration: "dateOfRegistration" as const,
}

